module.exports = __webpack_public_path__ + "static/img/service_content1-1_icon.421f3dd.png";